export function parseAppId(fullAppId: string) {
  const [appName, directoryWithNamespace] = fullAppId.split('@');
  const [namespace, directory] = directoryWithNamespace.split('.');
  return { appName, namespace, directory };
}

export function createAppId(
  appName: string,
  namespace: string,
  directory: string,
) {
  return `${appName}@${namespace}.${directory}`;
}
